import { FormErrorsType, Input } from '@/components'
import { FormChangeEventHandler, JsonDataType } from '@/types'

export interface WarrantyHolderFormDataType extends JsonDataType {
    first_name: string
    last_name: string
    email: string
    phone: string
}

type WarrantyHolderFormProps = {
    form: WarrantyHolderFormDataType
    onChange: FormChangeEventHandler
    errors: FormErrorsType
}
export const WarrantyHolderForm = ({ form, errors, ...props }: WarrantyHolderFormProps) =>
    <>
        <Input
            id="first_name"
            name="first_name"
            errors={errors.first_name}
            label="First Name*"
            placeholder="Name"
            onChange={props.onChange}
            value={form.first_name}
        />
        <Input
            id="last_name"
            name="last_name"
            errors={errors.last_name}
            label="Last Name*"
            placeholder="Name"
            onChange={props.onChange}
            value={form.last_name}
        />
        <Input
            id="email"
            name="email"
            type="email"
            errors={errors.email}
            label="Email*"
            placeholder="email@email.com"
            onChange={props.onChange}
            value={form.email}
        />
        <Input
            id="phone"
            name="phone"
            errors={errors.phone}
            label="Phone"
            placeholder="(###) ###-####"
            onChange={props.onChange}
            value={form.phone}
            mask={{ mask: '(000) 000-0000' }}
        />
    </>
